import api from "@/lib/api";

// Mobile number + OTP sign-in with Firebase Authentication. The Firebase SDK
// is loaded only when someone uses it (keeps the main bundle small), with the
// web settings from GET /api/auth/phone/config.

let _state = null;   // { auth, fb } once initialised

export async function phoneLoginConfig() {
  try {
    const { data } = await api.get("/auth/phone/config");
    return data;
  } catch { return { enabled: false }; }
}

async function init() {
  if (_state) return _state;
  const cfg = await phoneLoginConfig();
  if (!cfg.enabled) throw new Error("Mobile number sign-in isn't available right now. Use email instead.");
  const [{ initializeApp, getApps }, fb] = await Promise.all([import("firebase/app"), import("firebase/auth")]);
  const app = getApps()[0] || initializeApp(cfg.firebase);
  const auth = fb.getAuth(app);
  auth.languageCode = "en";
  _state = { auth, fb };
  return _state;
}

const MESSAGES = {
  "auth/invalid-phone-number": "That mobile number doesn't look right.",
  "auth/invalid-verification-code": "That code is wrong. Check the SMS and try again.",
  "auth/code-expired": "The code has expired. Request a new one.",
  "auth/too-many-requests": "Too many attempts. Please wait a few minutes and try again.",
  "auth/quota-exceeded": "We can't send more codes right now. Please try again later or use email.",
  "auth/captcha-check-failed": "Security check failed. Reload the page and try again.",
  "auth/unauthorized-domain": "Mobile sign-in isn't enabled for this website yet. Use email for now.",
  "auth/operation-not-allowed": "Mobile sign-in isn't enabled yet. Use email for now.",
  "auth/billing-not-enabled": "SMS sending isn't enabled yet. Use email for now.",
  "auth/network-request-failed": "No internet connection. Check your network and try again.",
};
export const friendlyError = (e) => MESSAGES[e?.code] || e?.message || "Something went wrong. Please try again.";

/** Send the SMS code. `buttonId` is the element the invisible reCAPTCHA binds to. */
export async function sendCode(phone10, buttonId) {
  const { auth, fb } = await init();
  if (window.__pbRecaptcha) { try { window.__pbRecaptcha.clear(); } catch { /* already gone */ } }
  window.__pbRecaptcha = new fb.RecaptchaVerifier(auth, buttonId, { size: "invisible" });
  const confirmation = await fb.signInWithPhoneNumber(auth, `+91${phone10}`, window.__pbRecaptcha);
  return confirmation;
}

/** Check the code; returns the Firebase ID token to send to our backend. */
export async function confirmCode(confirmation, code) {
  const cred = await confirmation.confirm(code);
  const token = await cred.user.getIdToken();
  // Our backend session is what counts; don't keep a Firebase session around.
  try { const { auth } = await init(); await auth.signOut(); } catch { /* ignore */ }
  return token;
}
